/**
 * Classe que formata os tipos baseado em array, Tag, Lookup, lookup_list, PICKLIST_MULTISELECT
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.ARRAY_BASED = (function () {

    function ARRAY_BASED(value) {

        Monet.Format.Base.apply(this, arguments);

        this.value = value;

        this.formatToString = function () {

            if (typeof this.value === "object") {
                this.value = this.value.join(', ');
            }

            return this;

        };

    }

    return ARRAY_BASED;

}());